import { FC } from 'react';
import styled, { css } from 'styled-components';

import Text from '@/components/Text';

const Badge = styled.div<{ $color: 'error' | 'warning' | 'success' }>`
  white-space: nowrap;
  display: flex;
  border-radius: 4px;
  padding: 0 6px;
  height: 18px;
  align-items: center;
  ${({ theme, $color }) =>
    $color === 'error' &&
    css`
      background: ${theme.colors.error};
    `}
  ${({ theme, $color }) =>
    $color === 'warning' &&
    css`
      background: ${theme.colors.warning};
    `}
    ${({ theme, $color }) =>
    $color === 'success' &&
    css`
      background: ${theme.colors.success};
    `}
`;

interface Props {
  currentValue: number;
  baseValue?: number;
}

const SponsornameStatsBadge: FC<Props> = ({ currentValue, baseValue }) => {
  if (!baseValue) {
    return null;
  }

  const differenceInPercent = ((currentValue - baseValue) / baseValue) * 100;

  if (
    differenceInPercent === 0 ||
    isNaN(differenceInPercent) ||
    differenceInPercent === Infinity
  ) {
    return null;
  }

  const renderbadgeColor = () => {
    if (differenceInPercent <= -5) return 'error';
    if (differenceInPercent <= 5) return 'warning';
    return 'success';
  };

  return (
    <Badge $color={renderbadgeColor()}>
      <Text $color="white" $type="extraSmall">
        {differenceInPercent.toFixed(2)} %
      </Text>
    </Badge>
  );
};

export default SponsornameStatsBadge;
